import {
  Typography,
  Container,
  Grid2,
  Box,
  Paper
} from '@mui/material';
import { } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import CreateAccountWidget from '../CreateAccountWidget';
import InstallPWAButton from '../Components/PWA'
import LoginWidget from '../LoginWidget';
import React from 'react';

const HomeScreen = () => {
  const isMobile = useMediaQuery('(max-width:1300px)');
  const [isCreatingAccount, setIsCreatingAccount] = React.useState(false);

  return (
    <Box
      sx={{
        flexGrow: 1, // Make the main content take available space
        padding: 2,
      }}
    >

      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
        <Box sx={{ width: { xs: '100%', md: '75%' } }} >
          {/* Container for grid items */}
          <Container>
            <Grid2 item xs={12} md={4}>
              <Paper sx={{ marginBottom: 1, padding: 2, height: "100%" }}>
                {/* Typography content */}
                <Typography variant="h4" sx={{ marginTop: 2 }} style={{ textAlign: 'center' }}>
                  Nau mai, haere mai ki tēnei rōpu
                </Typography>
              </Paper>
              {/* Image at the top */}
              <img
                src="/WelcomeScreen.jpg" // Replace with your image URL or path
                alt="Description of Image" // Provide an alt text for accessibility
                style={{ width: "100%", height: "auto", borderRadius: "8px", marginBottom: '0.5vh' }} // Style for the image
              />
            </Grid2>
          </Container>

          <Container>
            <Box
              sx={{
                display: 'flex',
                gap: 2, // Space between items
                flexDirection: { xs: 'column', md: 'row' }, // Stack on small screens, side-by-side on larger screens
              }}
            >
              <Paper sx={{ display: { xs: 'none', md: 'flex' }, flex: 1, padding: 2 }} style={{}}>
                <Typography sx={{}} variant="body1" style={{ textAlign: 'center' }}>
                  Rōpū Whakatau serves as an online discussion platform where people are able to meet to discuss a series of topics with the goal of reaching a consensus.
                  The aim is to apply Mātauranga Māori Principles to this specific platform making Rōpū Whakatau an immersive face to face meeting environment.
                </Typography>
              </Paper>


              {isMobile ? (<></>) : (
                <Box sx={{ flex: 1 }}>
                  <img
                    src="/wallace-fonseca-uCistv3i1nw-unsplash.jpg"
                    alt="Group Meeting"
                    style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
                  />
                  Photo by <a href="https://unsplash.com/@waally?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Wallace Fonseca</a> on <a href="https://unsplash.com/photos/a-man-with-a-beard-and-tattoos-standing-next-to-a-body-of-water-uCistv3i1nw?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Unsplash</a>
                </Box>
              )}
            </Box>
          </Container>
        </Box>
        <Box sx={{ width: { xs: '100%', md: '25%' } }}>
          {isCreatingAccount ? (
            <CreateAccountWidget setIsCreatingAccount={setIsCreatingAccount} />) : (
            <LoginWidget setIsCreatingAccount={setIsCreatingAccount} />
          )}
        </Box>
      </Box>
      <Box sx={{
        flex: 1,
        display: 'flex',          // This "turns on" the centering powers
        flexDirection: 'column',
        alignItems: 'center',     // Centers horizontally
        justifyContent: 'center',  // Centers vertically
        width: '100%'
      }}>
        {isMobile ? (
          <>
            <Typography variant="h5" sx={{ marginTop: 4, }}>Want an app version instead?</Typography>
            <InstallPWAButton />
          </>) : null}
      </Box>
    </Box>
  );
};

export default HomeScreen;
